var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// server/utils/energyPeriod.js
var require_energyPeriod = __commonJS({
  "server/utils/energyPeriod.js"(exports, module) {
    var ENERGY_PERIODS = {
      DAY: "day",
      MONTH: "month",
      YEAR: "year"
    };
    var DEFAULT_ENERGY_PERIOD_START_DAY = 1;
    var MIN_ENERGY_PERIOD_START_DAY = 1;
    var MAX_ENERGY_PERIOD_START_DAY = 31;
    function getDaysInMonth(year, monthIndex) {
      return new Date(year, monthIndex + 1, 0).getDate();
    }
    function getPeriodStartDayInMonth(year, monthIndex, startDay) {
      return Math.min(startDay, getDaysInMonth(year, monthIndex));
    }
    function parseEnergyPeriodStartDay(value) {
      if (value === void 0 || value === null || value === "") {
        return DEFAULT_ENERGY_PERIOD_START_DAY;
      }
      const parsedValue = Number(value);
      if (!Number.isInteger(parsedValue) || parsedValue < MIN_ENERGY_PERIOD_START_DAY || parsedValue > MAX_ENERGY_PERIOD_START_DAY) {
        return null;
      }
      return parsedValue;
    }
    function getEnergyPeriodStartInCalendarUnit(date, period, startDay = DEFAULT_ENERGY_PERIOD_START_DAY) {
      const currentDate = new Date(date);
      const year = currentDate.getFullYear();
      const monthIndex = currentDate.getMonth();
      if (period === ENERGY_PERIODS.YEAR) {
        return new Date(year, 0, startDay, 0, 0, 0, 0);
      }
      if (period === ENERGY_PERIODS.MONTH) {
        return new Date(year, monthIndex, getPeriodStartDayInMonth(year, monthIndex, startDay), 0, 0, 0, 0);
      }
      return new Date(year, monthIndex, currentDate.getDate(), 0, 0, 0, 0);
    }
    function getEnergyPeriodStart(date, period, startDay = DEFAULT_ENERGY_PERIOD_START_DAY) {
      const currentDate = new Date(date);
      const periodStartInCalendarUnit = getEnergyPeriodStartInCalendarUnit(currentDate, period, startDay);
      if (currentDate >= periodStartInCalendarUnit) {
        return periodStartInCalendarUnit;
      }
      return getPreviousEnergyPeriodStart(periodStartInCalendarUnit, period, startDay);
    }
    function getNextEnergyPeriodStart(periodStart, period, startDay = DEFAULT_ENERGY_PERIOD_START_DAY) {
      const currentDate = new Date(periodStart);
      const year = currentDate.getFullYear();
      const monthIndex = currentDate.getMonth();
      if (period === ENERGY_PERIODS.YEAR) {
        return new Date(year + 1, 0, startDay, 0, 0, 0, 0);
      }
      if (period === ENERGY_PERIODS.MONTH) {
        return new Date(year, monthIndex + 1, getPeriodStartDayInMonth(year, monthIndex + 1, startDay), 0, 0, 0, 0);
      }
      return new Date(year, monthIndex, currentDate.getDate() + 1, 0, 0, 0, 0);
    }
    function getPreviousEnergyPeriodStart(periodStart, period, startDay = DEFAULT_ENERGY_PERIOD_START_DAY) {
      const currentDate = new Date(periodStart);
      const year = currentDate.getFullYear();
      const monthIndex = currentDate.getMonth();
      if (period === ENERGY_PERIODS.YEAR) {
        return new Date(year - 1, 0, startDay, 0, 0, 0, 0);
      }
      if (period === ENERGY_PERIODS.MONTH) {
        return new Date(year, monthIndex - 1, getPeriodStartDayInMonth(year, monthIndex - 1, startDay), 0, 0, 0, 0);
      }
      return new Date(year, monthIndex, currentDate.getDate() - 1, 0, 0, 0, 0);
    }
    module.exports = {
      ENERGY_PERIODS,
      DEFAULT_ENERGY_PERIOD_START_DAY,
      MIN_ENERGY_PERIOD_START_DAY,
      MAX_ENERGY_PERIOD_START_DAY,
      getDaysInMonth,
      getPeriodStartDayInMonth,
      parseEnergyPeriodStartDay,
      getEnergyPeriodStartInCalendarUnit,
      getEnergyPeriodStart,
      getNextEnergyPeriodStart,
      getPreviousEnergyPeriodStart
    };
  }
});
const __cjsModule = require_energyPeriod();
export default __cjsModule;
export const ENERGY_PERIODS = __cjsModule.ENERGY_PERIODS;
export const DEFAULT_ENERGY_PERIOD_START_DAY = __cjsModule.DEFAULT_ENERGY_PERIOD_START_DAY;
export const MIN_ENERGY_PERIOD_START_DAY = __cjsModule.MIN_ENERGY_PERIOD_START_DAY;
export const MAX_ENERGY_PERIOD_START_DAY = __cjsModule.MAX_ENERGY_PERIOD_START_DAY;
export const getDaysInMonth = __cjsModule.getDaysInMonth;
export const getPeriodStartDayInMonth = __cjsModule.getPeriodStartDayInMonth;
export const parseEnergyPeriodStartDay = __cjsModule.parseEnergyPeriodStartDay;
export const getEnergyPeriodStartInCalendarUnit = __cjsModule.getEnergyPeriodStartInCalendarUnit;
export const getEnergyPeriodStart = __cjsModule.getEnergyPeriodStart;
export const getNextEnergyPeriodStart = __cjsModule.getNextEnergyPeriodStart;
export const getPreviousEnergyPeriodStart = __cjsModule.getPreviousEnergyPeriodStart;
